import { connect } from 'react-redux';
import Cart        from '../components/Cart';

const mapStateToProps = state => ({
  parameters       : state.get('parameters').toJS(),
  parametersChanged: state.get('parametersChanged'),
  quote            : state.get('quote').toJS(),
  quoteStep        : state.get('quoteStep'),
});

const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(Cart);
